/* eslint-disable */
const saveUsers = function(state, data) {
  // state.userList = data;
  console.error("@refactor: not saving user list to state", data);
};
const saveUsersAdmin = function(state, data) {
  // state.userListAdmin = data;
  console.error("@refactor: not saving user list admin to state", data);
};
const saveGroups = function(state, data) {
  state.groupList = data;
};
const saveSubgroups = function(state, data) {
  state.subgroupList = data;
};
const saveGroupItems = function(state, data) {
  state.groupitemList = data;
};
const saveGroupUsers = function(state, data) {
  state.groupUsers = data;
};
const saveEmails = function(state, data) {
  state.emailList = data;
};
const saveInstall = function(state, data) {
  state.installs = data;
};
const saveInstalls = function(state, data) {
  state.installss = data;
};
const saveSms = function(state, data) {
  state.smsList = data;
};
const setGlobalTableOptions = function(state, data) {
  state.globalTableOptions = data;
};
const setAccess = function(state, data) {
  state.userAccess = data;
};
const saveDevices = function(state, data) {
  state.deviceList = data;
};
const setUser = function(state, data) {
  state.loggedInUser = data;
};
const setUserAmount = function(state, data) {
  state.userAmount = data;
};
const setHome = function(state, data) {
  state.isHome = data;
};
const setDrawerMode = function(state, data) {
  state.drawerMode = data;
};
const setRole = function(state, data) {
  state.roles = data;
};
const setRoleAdmin = function(state, data) {
  state.rolesAdmin = data;
};
const toggleSidebar = function(state, data) {
  state.isSidebarCollapsed = data;
  console.log("SIDEBAR", state.isSidebarCollapsed);
};
const setTheme = function(state, data) {
  if (data) {
    state.activeTheme = data;
    // console.log(state.activeTheme);
  } else {
    state.activeTheme = state.defaultTheme;
  }
};

const fillDeviceList = (state, list) => {
  state.allDevices = list;
};

const devicePayload = (state, list) => {
  state.devicePayload = list;
};

const loadingState = (state, list) => {
  state.loadingState = list;
};

const graphDeviceDetails = (state, list) => {
  // console.log(list.data);

  state.allGraphDevices = list;
};
//uniqueFV
// filteredAllDevices
// filteredOnlineDevices
// uniqueSectors
const uniqueSectors = (state, list) => {
  state.uniqueSectors = list;
};

const filteredAllDevices = (state, list) => {
  state.filteredAllDevices = list;
};

const filteredOnlineDevices = (state, list) => {
  state.filteredOnlineDevices = list;
};
const filteredOffLineDevices = (state, list) => {
  state.filteredOffLineDevices = list;
};

const filteredAlarmDevices = (state, list) => {
  state.filteredAlarmDevices = list;
};
const setCriticalSystems = (state, list) => {
  state.criticalSystems = list;
};

const uniqueFV = (state, list) => {
  state.uniqueFV = list;
};
const uniquePaymentModel = (state, list) => {
  state.uniquePaymentModel = list;
};
const onLineDevices = (state, list) => {
  state.onLineDevices = list;
};
const filterFirmWarVersion = (state, list) => {
  state.filterFirmWarVersion = list;
};
const filterPaymentModel = (state, list) => {
  state.filterPaymentModel = list;
};
const filterSectorVal = (state, list) => {
  state.filterSectorVal = list;
};
const offLineDevices = (state, list) => {
  // state.offLineDevices = list;
  console.log("@refactor: not saving offline devices to state", list);
};
const alarmDevices = (state, list) => {
  // state.alarmDevices = list;
  console.log("@refactor: not saving alarm devices to state", list);
};
const updateWarning = (state, deviceWarning) => {
  state.devicesWarning = {
    ...state.devicesWarning,
    [deviceWarning["DeviceID"]]: deviceWarning["payload"]
  };
};

const fillOffDeviceList = (state, list) => {
  state.allOffDevices = list;
};
const setPerformanceFilter = (state, performanceFilter) => {
  state.performanceFilter = performanceFilter;
};

const setDeviceCurrentSettings = (state, currentSettings) => {
  state.deviceCurrentSettings = currentSettings;
};

const saveOsCustomer = (state, customer) => {
  localStorage.setItem("osCustomer", customer);
  state.osCustomer = customer;
};

const saveCustomerProductOptions = (state, options) => {
  state.customerProductOptions = options;
};
const saveOnboanrdingState = (state, options) => {
  console.log({ options });
  state.onboanrdingState = options;
};

const saveOnboardingPackageType = (state, options) => {
  state.onboardingPackageType = options;
};

const saveOnboardingCustomerState = (state, value) => {
  state.onboardingCustomerState = value;
};

const saveUserNotifications = (state, data) => {
  state.userNotifications = data;
};

const setAssignedDevices = (state, data) => {
  state.assignedDevices = data;
};

const setActiveDeviceDaysToExpire = (state, data) => {
  state.activeDeviceDaysToExpire = data;
};

export default {
  toggleSidebar,
  devicePayload,
  saveUsers,
  loadingState,
  saveUsersAdmin,
  saveGroups,
  saveSubgroups,
  saveGroupItems,
  saveGroupUsers,
  saveEmails,
  saveSms,
  saveDevices,
  saveInstall,
  saveInstalls,
  saveDevices,
  setUser,
  setUserAmount,
  setAccess,
  setHome,
  setDrawerMode,
  fillDeviceList,
  fillOffDeviceList,
  updateWarning,
  setRole,
  setRoleAdmin,
  setTheme,
  graphDeviceDetails,
  offLineDevices,
  alarmDevices,
  onLineDevices,
  uniqueFV,
  filteredAllDevices,
  filteredOnlineDevices,
  filteredOffLineDevices,
  filteredAlarmDevices,
  filterFirmWarVersion,
  filterSectorVal,
  uniqueSectors,
  uniquePaymentModel,
  filterPaymentModel,
  setGlobalTableOptions,
  setPerformanceFilter,
  setCriticalSystems,
  setDeviceCurrentSettings,
  saveOsCustomer,
  saveCustomerProductOptions,
  saveUserNotifications,
  setAssignedDevices,
  setActiveDeviceDaysToExpire,
  saveOnboanrdingState,
  saveOnboardingPackageType,
  saveOnboardingCustomerState
};



// WEBPACK FOOTER //
// ./src/store/mutations.js